import {Keys} from "../const.js";

export default class congrats {
  constructor(siteBodyElement) {
    this._state = { congratsActivate: false, };
    this._siteBodyElement = siteBodyElement;
    this._buttonShowCongrats = this._siteBodyElement.querySelector(`.wheel-fortune__images-choose`);
    this._spinnerWheelElement = this._siteBodyElement.querySelector(`.spinner__wheel`);
    this._spinnerButtonElement = this._siteBodyElement.querySelector(`.spinner__button`);
    this._iconCongrats = this._siteBodyElement.querySelector(`#icon-choose-use`);
    this._congrats = this._siteBodyElement.querySelector(`.congrats`);
    this._congratsClose = this._congrats.querySelector(`.congrats__button-close`)

    this._escKeyDownHandler = this._escKeyDownHandler.bind(this);
    this._showCongratsPopup = this._showCongratsPopup.bind(this);
  }

  init() {
    this._state = { congratsActivate: true };
    this._spinnerWheelElement.classList.add(`active`);
    this._spinnerButtonElement.classList.add(`active`);
    this._buttonShowCongrats.classList.add(`active`);
    this._buttonShowCongrats.addEventListener(`click`, this._showCongratsPopup);
    this._congratsClose.addEventListener(`click`, this._showCongratsPopup);
  }

  shakeButtonShowCongrats() {
    this._buttonShowCongrats.classList.add(`shake`);
    setTimeout(() => {
      this._buttonShowCongrats.classList.remove(`shake`);
    }, 20000);
  }

  _showCongratsPopup(event) {
    event.preventDefault();
    if (this._congrats.classList.contains(`congrats_open`)) {
      this._closeCongratsPopup(event);
    } else {
      ('ga' in window) && ga('send', 'event', 'SpecialProject', '23feb21_gift');
      this._siteBodyElement.classList.add(`popup-open`);
      this._congrats.classList.add(`congrats_open`);
      document.addEventListener(`keydown`, this._escKeyDownHandler);
    }
  }

  _closeCongratsPopup(event) {
    event.preventDefault();
    document.removeEventListener(`keydown`, this._escKeyDownHandler);
    this._siteBodyElement.classList.remove(`popup-open`);
    this._congrats.classList.remove(`congrats_open`);
  }

  _escKeyDownHandler(event) {
    if (event.key === Keys.ESC || event.key === Keys.ESCAPE) {
      this._closeCongratsPopup(event);
    }
  }
}
